// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue                  from 'vue'
import App                  from './App'
import VueRouter            from "vue-router"
import router               from './router'
import axios                from 'axios'
import VueTheMask           from 'vue-the-mask'
import VueMoney             from 'v-money'
import mobile               from 'mobile-device-detect';
// import Autocomplete         from '@trevoreyre/autocomplete-vue'
// import '@trevoreyre/autocomplete-vue/dist/style.css'
// import VueAwesomeSwiper     from 'vue-awesome-swiper'
// import 'vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css'

// var url                     = "http://localhost:8081";
var url                     = "https://agendamaster.negociar.tech";
Vue.use(VueRouter)
// Vue.use(VueTrumbowyg);
Vue.use(VueTheMask)
Vue.use(VueMoney)
Vue.use(mobile)
// Vue.use(VueAwesomeSwiper)
// Vue.use(Autocomplete)
window.axios                = axios
axios.defaults.baseURL      = url;
Vue.config.productionTip    = false
window._app;
Vue.config.ignoredElements = [/^ion-/]

if (!window.cordova && location.hostname != "localhost") {
    window.console.log      = function(){};
}
if (window.cordova || location.hostname != "localhost") {
    axios.defaults.timeout  = 60000;
}

Vue.filter('nl2br', function (str) {
    return str.replaceAll('\\n', '<br/>');
});

/* eslint-disable no-new */
new Vue({
    el:                  '#app',
    router,
    components: {
        App
    },
    template:            '<App/>',

    data: {
        "ready":        false,
        "logged":       false,
        "viagem":       null,
        "formViagem":   {},
        "modo":         null,        
        "cordova":      window.cordova || null,
        "user":  {
            "cod":      null,
            "token":    null,
            "nome":     null,
            "tipo":     "contratante"
            // "tipo":     "admin"
            // "tipo":     window.localStorage.getItem("_tipo") || "contratante"
        },
        "mobile":       mobile,
        "tmp":  {
        },
        "modal": {
        },
        "avaliacao":            null,
        "formAvaliacao": {
            "_cod":             "",
            "_token":           "",
            "texto":            "",
            "nota":             null,
            "cod":              "",
        },               
        "modalEnderecoClose": true,
        "modalEndereco":    false,
        "formEndereco": {
            "_cod":             "",
            "_token":           "",
            "acao":             "endereco",
            "cod":              "",                
            "cep":              "",
            "endereco":         "",
            "numero":           "",
            "bairro":           "",
            "cidade":           "",
            "estado":           "",
        },     
        "curriculo": {
            "descricao":        ""
        },
        "cacheDefault": {
            "inicioCatalogo": {
                "filtro":   null,
                "data":     null,
            },
            "inicioPrestadores": {
                "filtro":   null,
                "data":     null,
            },  
            "inicioPendentes": {
                "filtro":   null,
                "data":     null,
            },                        
            "catalogo": {
                "filtro":   null,
                "data":     null,
            },
            "prestadores": {
                "filtro":   null,
                "data":     null,
            },            
            "categorias": {
                "data":     null
            }
        },
        "cache":        {
            "inicioCatalogo": {
                "filtro":   null,
                "data":     null,
            },
            "inicioPrestadores": {
                "filtro":   null,
                "data":     null,
            },       
            "inicioPendentes": {
                "filtro":   null,
                "data":     null,
            },         
            "prestadores": {
                "filtro":   null,
                "data":     null,
            },                                                        
            "catalogo": {
                "filtro":   null,
                "data":     null,
            },
            "categorias": {
                "data":     null
            }            
        },   
        "internet":      {
            "online":   true  
        },        
        "geolocationVezes":     0,
        "geolocationErro":      false,
        "geolocationGrupo":     "regiao-1",
        "distanciaRaio":        null,
        "distanciaDestino":     null,
        "distanciaIntegrantes": null,        
        "geolocation": {
            "try":            0,
            "latitude":       -27.015129,
            "longitude":      -48.652892
            // "latitude":       null,
            // "longitude":      null
        },                 
        "config": {
            "url":      url,
            "googleAnalytics": {
                "id":   ""
            },
            "pusher": {
                "key": "670cf71549d1536ad6a9"
            },  
            "money": {
                "decimal":            ',',
                "thousands":          '.',
                "prefix":             '',
                "suffix":             '',
                "precision":          2,
                "masked":             false
            }                
        }
    },
    methods: {
        initialize: function() {
            console.log("app.initialize()");
            var self             = this;

            gtag('js', new Date());
            gtag('config', self.config.googleAnalytics.id);

            window.confirmWeb   = window.confirm;
            window.confirm      = function(msg, callback) {
                if (window.confirmWeb(msg)) {
                    callback();
                }
            }

            var self        = this;
            document.addEventListener('deviceready', this.onDeviceReady.bind(this), false);
            var login       = self.checkLogin();
            self.fixClass();

            window.__onResume = function() {
                console.log("onResume");
                window.__app.getUser();
                // window.__app.getViagens();
                if (window.__app.$route.name == "Dashboard") {
                    // if (window.__resume) window.__resume();
                }
            }
            document.removeEventListener("resume", window.__onResume, false);
            document.addEventListener("resume", window.__onResume, false);

            // if (!window.localStorage.getItem("_intro")) {
            //     self.go("Introducao");
            //     return false;
            // }            


            Pusher.logToConsole  = false;
            self.pusher          = new Pusher(self.config.pusher.key, {
                cluster:        'mt1',
                activityTimeout: 2000,
                enabledTransports: ['ws']
            });
            self.pusher.connection.bind('state_change', function(states) {
              states = {previous: 'oldState', current: 'newState'}
              console.log("PUSHER >>>>> Channels current state is ", states);
            });   
                   
        },
        menu: function() {
            var self = this;
            console.log("menu");
            window.___app.dialog.create({
                title: 'Agenda Master',
                text: '',
                buttons: [
                    {
                        text: 'Minha conta',
                        onClick: function() {
                            self.$root.go("Conta");
                        }
                    },
                    {
                        text: 'Alterar senha',
                        onClick: function() {
                            self.$root.go("AlterarSenha");
                        }
                    },             
                    {
                        text: 'Fale conosco',
                        onClick: function() {
                            self.$root.go("Contato");
                        }
                    },
                    {
                        text: 'Termos de uso',
                        onClick: function() {
                            loading.show();
                            setTimeout(function() {
                                self.$root.openModal('modal-termos-de-uso');
                            }, 500);
                        }
                    },      
                    {
                        text: 'Políticas de privacidade',
                        onClick: function() {
                            loading.show();
                            setTimeout(function() {
                                self.$root.openModal('modal-politicas-de-privacidade');
                            }, 500);
                            
                        }
                    },   
                    {
                        text: 'Deslogar',
                        onClick: function() {
                            self.$root.logout();
                        }
                    },                                                            
                    {
                        text: '<span style="color: red; font-weight: 200">Voltar<span>',
                    },                                                            
                ],
                verticalButtons: true,
            }).open();            
        },            
        changeEndereco: function(e) {
            var self    = this;
            console.log("changeEndereco()", e);
            setTimeout(function() {
                console.log("Endereco Cod:", self.formEndereco.cod);
                if (!self.formEndereco.cod) {
                    self.formEndereco = {
                        "_cod":             self.user.cod,
                        "_token":           self.user.token,
                        "acao":             "endereco",                
                        "cod":              "",
                        "cep":              "",
                        "endereco":         "",
                        "complemento":      "",
                        "numero":           "",
                        "bairro":           "",
                        "cidade":           "",
                        "estado":           "",
                    };
                    self.$forceUpdate();
                } else {
                    var endereco = self.$root.user.enderecos.filter(function(item) {
                        if (item.cod == self.formEndereco.cod) return item;
                    })[0];

                    console.log("Achou endereco", endereco)

                    self.formEndereco.cod           = endereco.cod;
                    self.formEndereco.endereco      = endereco.endereco;
                    self.formEndereco.estado        = endereco.estado;
                    self.formEndereco.cep           = endereco.cep;
                    self.formEndereco.complemento   = endereco.complemento;
                    self.formEndereco.cidade        = endereco.cidade;
                    self.formEndereco.bairro        = endereco.bairro;
                    self.formEndereco.numero        = endereco.numero;   
                    self.submitEndereco(false);                   
                }
            }, 100);
        },
        atualizarCEP: function(val) {
            var self    = this;
            if (val) {
                if (val.length == 9) {
                    axios.get("https://viacep.com.br/ws/" + val.replace("-", "") + "/json/", {})
                    .then(response => {
                        if (response.data) {
                            if (response.data.logradouro) {
                                self.formEndereco.endereco  = response.data.logradouro;
                                self.formEndereco.bairro    = response.data.bairro;
                                self.formEndereco.cidade    = response.data.localidade;
                                self.formEndereco.estado    = response.data.uf;
                                self.$forceUpdate();
                            }
                        }
                    })
                    .catch(error => {
                    });
                }
            }
        },    
        submitEndereco: function(e) {
            var self = this;
            console.log("submitEndereco()");
            loading.show();

            var geocoder                = new google.maps.Geocoder();
            var endereco                = self.formEndereco.endereco + ", " + self.formEndereco.numero + " - " + self.formEndereco.bairro + ", " + self.formEndereco.cidade + " - " + self.formEndereco.estado + ", " + self.formEndereco.cep;
            geocoder.geocode({ 'address': endereco}, function (results, status) {

                console.log("Localizacao resultado >>", results)

                if (results[0]) {

                    var latitude        = results[0].geometry.location.lat();
                    var longitude       = results[0].geometry.location.lng();
                    self.formEndereco.latitude  = latitude;
                    self.formEndereco.longitude = longitude;
                    console.log("Setou localizacao", self.form);
                    self.$forceUpdate();
                    
                    axios.put("api/conta.php", self.formEndereco)
                    .then(response => {
                      
                        console.log("ok", response.data.result)
                        if (e) self.modalEndereco = false;
                        self.$forceUpdate();
                        loading.hide();
                        self.getUser();
                        // self.$root.setUser(response.data.result);
                        // alert(response.data.message);
                        
                    })
                    .catch(error => {
                        loading.hide();
                       
                        alert(error.response.data.message || "Erro! Por favor, tente novamente.");
                    });
                } else {
                    loading.hide();
                    alert("Erro! Informe um endereço válido e tente novamente por favor.")
                }
            });
        },          
        setAvaliacaoNota: function(nota) {
            console.log("setAvaliacaoNota()", nota);
            var self = this;
            self.formAvaliacao.nota = nota;
            self.$forceUpdate();
        },                    
        setAvaliacao: function(data) {
            var self = this;
            console.log("setAvaliacao()", data);
            if (self.avaliacao) return false;
            self.formAvaliacao = {
                "texto":        "",
                "nota":         "",
            };
            self.avaliacao = data;
            self.$forceUpdate();
        },
        submitAvaliacao: function() {
            var self            = this;
            loading.show();
            self.formAvaliacao._cod      = self.$root.user.cod;
            self.formAvaliacao._token    = self.$root.user.token;
            self.formAvaliacao.pedidoCod = self.avaliacao.cod;
          
                
            axios.post("api/avaliacoes.php", self.formAvaliacao)
            .then(response => {
                
                console.log("submitAvaliacao() response", response)
                alert(response.data.message);
                if (response.data.result) {
                    // self.setViagem(null);
                    self.avaliacao = null;
                    self.$forceUpdate();
                    // self.getAvaliacoesPendentes();
                }
                setTimeout(function() {
                    loading.hide();
                }, 1000);

        
            })
            .catch(error => {
                console.log("submitAvaliacao() error", error)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },                     
        scrollTop: function() {
            setTimeout(function() {
                $(".page-content")[0].scrollTo({
                    top:    0
                });     
            }, 100);
        },         
        atualizarPushToken: function() {
            console.log("push > atualizarPushToken()")
            var self = this;
            if (self.logged && window.localStorage.pushToken) {
                axios.post("api/push-notification.php", {
                    "_cod":         self.user.cod,
                    "_token":       self.user.token,
                    "dispositivo":  self.mobile.osName,
                    "pushToken":    localStorage.getItem('pushToken')
                })
                .then(response => {
                    window.localStorage.setItem("pushTokenSalvo", new Date());
                    console.log("push > Salvou push", response)
                })
                .catch(error => {
                    console.log("push > Erro:", error)
                });                 
            }                
        },
        checkPushNotificationPermission: function(requested){
            var self = this;
            window.FirebasePlugin.hasPermission(function(hasPermission){
                if(hasPermission){
                    console.log("push > Remote notifications permission granted");
                    self.getPushNotificationToken();
                }else if(!requested){
                    console.log("push > Requesting remote notifications permission");
                    window.FirebasePlugin.grantPermission(self.checkPushNotificationPermission.bind(this, true));
                }else{
                    console.log("push > Notifications won't be shown as permission is denied");
                }
            });
        },    
        getPushNotificationToken: function(){
            var self = this;
            window.FirebasePlugin.getToken(function(token){
                console.log("push > Got FCM token: " + token);
                localStorage.setItem('pushToken', token);
                self.atualizarPushToken();
            }, function(error) {
                console.log("push > Failed to get FCM token", error);
            });
        },     
        go: function(route, data) {
            console.log("app.go()", route, data)
            var self = this;
            if (!data) {
                data = {};
            } else {
                data = JSON.parse(data);
                console.log("fez parse", data);
            }
            self.$router.push({ 
                name:       route,
                query:      data
            }).catch(()=>{});               
            $("body .overhang").fadeOut(500);
        },
        redirect: function(route) {
            console.log("app.redirect()", route)
            var self = this;
            self.$router.push({ 
                path:       route
            }).catch(()=>{});               
            $("body .overhang").fadeOut(500);
        },                  
        sequence: function(tasks, fn) {
            console.log("sequence()", tasks, fn)
            return tasks.reduce((promise, task) => promise.then(() => fn(task)), Promise.resolve());
        },    
        beep: function() {
            var self = this;
            var audio = new Audio('/static/beep1.mp3');   
            audio.play();
            if (window.cordova) {
                navigator.notification.beep(1);
            }

        },       
        onPushNotification: function(message) {
            console.log("push > onPushNotification()", message);
            var self        = this;

            if (self.mobile.osName == "iOS") {
                if (message.messageType == "notification" && message.aps) {
                    if (message.aps.alert) {
                        message.title   = message.aps.alert.title;
                        message.body    = message.aps.alert.body;
                    }
                }
            }
            if (message.messageType == "notification" && message.tap && message.link) {
                window.open(message.link, "_system");
                return false;
            }                        

            if (message.messageType == "notification" && message.tap && message.route) {
                loading.show();
                setTimeout(function() {
                    self.go(message.route, message.query || null);
                }, 3000);
            }

            if (message.messageType == "notification" && message.title && message.body) {

                window.__app.getUser();

                navigator.vibrate(1000); 
                navigator.notification.beep(1);

                if (message.route) {
                    if (message.route == self.$route.name) {
                        return false;
                    }
                    if (message.redirect) {
                        // loading.show();
                        // setTimeout(function() {
                            window.__app.go(message.route, window.ultimoPush.query);
                        // }, 3000);
                        // return false;
                    }
                }

                window.ultimoPush   = message;
                var link = "";
                if (message.route) {
                    link = "onclick='window.__app.go(\"" + message.route + "\", window.ultimoPush.query)'";
                } else if (message.link) {
                    link = "onclick='window.open(\"" + message.link + "\", \"_system\")'";
                }

                navigator.vibrate(1000); 
                navigator.notification.beep(1);

                $("body").overhang({
                    custom: true,
                    primary: "#FFFFFF",
                    accent: "#FFFFFF",
                    textColor: "#333333",
                    html: true,
                    message: "<a " + link + "><h4>" + message.title + "</h4><p>" + message.body + "</p></a>",
                    closeConfirm: "true",
                    customClasses: "push-notification",
                    callback: function (selection) {
                        console.log("callback notification", selection)
                        // if (message.route) {
                            
                            // iframe.src  = message.route;
                        // }
                    }
                });

            }

        },               
        onDeviceReady: function() {
            console.log("onDeviceReady()")
            var self    = this;

            self.$emit("onDeviceReady");            
            self.ready = true;

            // window.__app.getViagens();

            window.open = cordova.InAppBrowser.open;

            if(window.MobileAccessibility){
                console.log("Desativa fonte menor Android")
                window.MobileAccessibility.usePreferredTextZoom(false);
            }            

            self.checkPushNotificationPermission();

            window.FirebasePlugin.onMessageReceived(function(message) {
                console.log("push > onMessageReceived", message);
                try {
                    console.log(message);
                    self.onPushNotification(message);
                } catch(e) {
                    console.log("push > Exception in onMessageReceived callback: "+e.message);
                }

            }, function(error) {
                console.log("push > Failed receiving window.FirebasePlugin message", error);
            });

            window.FirebasePlugin.onTokenRefresh(function(token){
                console.log("push > Token refreshed: " + token)
                window.localStorage.setItem("pushToken", token);

            }, function(error) {
                console.log("push > Failed to refresh token", error);
            });


            self.backbutton = function(e){
                console.log("backbutton", e)
                e.preventDefault();

                if (window.__app.$route.name == "Introducao") {
                    return false;
                }

                if (window.__app.$route.name == "Inicio") {
                    return false;
                }

                self.back();
                return false;
            }

            document.addEventListener('backbutton', self.backbutton, false); 

            window.alert      = function(msg){
                navigator.notification.alert(msg, function(){}, "", "Ok");
            };

            window.confirm    = function(msg, callback){
                navigator.notification.confirm(msg, function(i) {
                    if (i == 1) {
                        callback();
                    }
                }, "", ['Sim', 'Cancelar']);
            };
            
        },
        limparPushToken: function() {
            console.log("push > limparPushToken()")
            var self = this;
            return new Promise(function(resolve, reject) {
                if (!self.logged) {
                    resolve(false);
                } else {
                    axios.post("api/push-notification.php", {
                        "_cod":         self.user.cod,
                        "_token":       self.user.token,
                        "dispositivo":  self.mobile.osName,
                        "pushToken":    ""
                    })
                    .then(response => {
                        window.localStorage.removeItem("pushToken");
                        console.log("push > Salvou push", response)
                        resolve(response.data)
                    })
                    .catch(error => {
                        resolve(error);
                        console.log("push > Erro:", error)
                    });                 
                }                
            });
        
        },                                  
        setUser: function(usuario) {
            var self    = this;
            return new Promise(function(resolve, reject) {
                window.localStorage.setItem("_usuario", JSON.stringify(usuario));
                self.logged    = true;
                self.user   = usuario;

                self.formEndereco = {
                    "_cod":             usuario.cod,
                    "_token":           usuario.token,
                    "acao":             "endereco",                
                    "cod":              usuario.enderecoCod,
                    "cep":              usuario.cep,
                    "endereco":         usuario.endereco,
                    "complemento":      usuario.complemento,
                    "numero":           usuario.numero,
                    "bairro":           usuario.bairro,
                    "cidade":           usuario.cidade,
                    "estado":           usuario.estado,
                }         

                // if (usuario.tipo == "contratante" && !usuario.cep && !usuario.endereco) {
                //     self.openModalEndereco(true);
                // }          
                resolve(usuario);

            });
        },
        getConfig: function(force) {
            var self        = this;
            console.log("getConfig()");
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "nome":         "configuracoes"
                    }
                };

                axios.get("api/itens.php", form)
                .then(response => {
                    
                    console.log("getConfig() response", response);

                    var diff    = false;
                    if (JSON.stringify(response.data.result.objeto) != JSON.stringify(self.config["configuracoes"])) {
                        diff    = true;
                    }

                    self.config["configuracoes"] = response.data.result.objeto; 
                    setTimeout(function() {
                        self.$forceUpdate();
                        if (diff) {
                            window.mmenuInit(true);
                        }
                    }, 100);

                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getConfig() error", error);
                    reject(error);
                    
                });   
            });   
        },                  
        getAvaliacoesPendentes: function() {
            var self        = this;
            console.log("getAvaliacoesPendentes()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                if (!self.logged || self.user.tipo != "contratante") {
                    resolve(false);
                    return false;
                }

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "pendentes"
                    }
                };

                axios.get("api/avaliacoes.php", form)
                .then(response => {
                    
                    console.log("getAvaliacoesPendentes() response", response);
                    
                    if (response.data.result.itens[0]) {
                        window.__app.beep();
                        window.__app.setAvaliacao(response.data.result.itens[0]);
                    }

                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getAvaliacoesPendentes() error", error);                    
                    // loading.hide();
                    reject(error);
          
                });   

            });   
        },        
        getUser: function(force) {
            var self        = this;
            console.log("getUser()");
            return new Promise(function(resolve, reject) {

                if (self.user.tipo == "contratante") {
                    self.getAvaliacoesPendentes();
                }
                self.getConfig();

                var form = {
                    "params": {
                        "_cod":         self.user.cod, 
                        "_token":       self.user.token
                    }
                };

                axios.get("api/usuarios.php", form)
                .then(response => {
                    
                    console.log("getUser() response", response);
                    self.setUser(response.data.result);
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getUser() error", error);
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.logout();
                        }
                    }
                    
                    reject(error);
                    
                });   
            });   
        },          
        checkLogin: function() {
            var self    = this;
            if (!window.localStorage.getItem("_usuario")) {
                return false;
            } else {
                var usuario = null;
                try {
                    usuario = JSON.parse(window.localStorage.getItem("_usuario"));
                    self.setUser(usuario);
                    self.getUser();
                    return true;
                } catch(err) {
                    console.log("checkLogin() error parse", err);
                    self.logout();
                    return false;
                }
            }
        },
        logout: function() {
            var self = this;
            console.log("logout()")
            loading.show();
            self.limparPushToken().finally(function() {
                $(".mm-menu").hide();
                $("#mm-blocker").hide();
                window.localStorage.clear();
                setTimeout(function() {
                    location.reload();
                }, 1000);
            });
        },
        back: function() {
            var self = this;
            console.log("back()", self, window.history.length);
            if ($(".tingle-modal--visible")[0]) {
                $(".tingle-modal--visible").hide();
                $(".tingle-modal").removeClass("tingle-modal--visible");
                console.log("back -> Esconde modal")
            } else {
                console.log("back -> Normal")

                if (window.history.length > 3) {
                    // $(".content-load .dashboard-container").fadeOut(100);                
                }

                // if (self.$route.meta.auth == false) {
                //     window.history.go(-3);
                // } else {
                    window.history.back();
                // }
            }

        },
        fixClass: function() {
            var self = this;
            if (self.$route) {
                // $("body").attr("class", "");
                // $("body").addClass("current-page-" + self.$route.name.toLowerCase());            
            }
        },
        addEvents: function() {
            var self = this;
            $("body").on("click", "a[target='_blank']", function(e) {
                console.log("open InAppBrowser", e.currentTarget.href, e);
                if (window.cordova) {
                    e.preventDefault();
                    window.open = cordova.InAppBrowser.open;
                    window.open(e.currentTarget.href, "_system");
                }

            });            
        },
        openModalEndereco: function(noClose) {
            var self        = this;
            console.log("openModalEndereco()");
            self.modalEndereco = true;
            self.modalEnderecoClose = !noClose ? true : false;
            self.$forceUpdate();
        },        
        openModalCurriculo: function(descricao) {
            var self = this;
            console.log("openModalCurriculo()", descricao);
            self.curriculo.descricao = descricao;
            self.openModal("modal-curriculo");
        },
        openModal: function(nome, html) {
            var self        = this;

            console.log("openModal()", nome)

            loading.show();

            self.modal[nome]   = new tingle.modal({
                footer:         false,
                stickyFooter:   false,
                closeMethods:   ['overlay', '', 'escape'],
                closeLabel:     "",
                cssClass:       [(nome), "modal-default"]
            });   

            setTimeout(function() {
                if (!html) {
                    self.modal[nome].setContent(document.querySelector('#' + nome).innerHTML);      
                } else {
                    self.modal[nome].setContent(html);      
                }
                self.modal[nome].open();
                loading.hide();
                setTimeout(function() {
                    $("." + nome).append('<a class="close" onclick=\'window.__app.modal["' + nome + '"].close();\'><i class="las la-times"></i></a>');    
                }, 100);
            }, 500);

        },
        clearCache: function() {
            console.log("clearCache()");
            var self = this;
            self.cache = JSON.parse(JSON.stringify(self.cacheDefault));
        }      
    },
    created: function() {
        var self = this;
        self.cache = JSON.parse(JSON.stringify(self.cacheDefault));
        console.log("setou cache inicial", self.cache)        
        window.__app    = self;
        console.log("SETOU APP", window.__app)
        
        if (!window.cordova) {
            setTimeout(function() {
                // console.log("Force onDeviceReady")
                self.ready = true;
                self.$forceUpdate();
            }, 5000)
        }

        self.initialize();  
        loading.show();
        self.addEvents();


        setTimeout(function() {
            window.___app = new Framework7({
                el: '#app',
                theme: "ios",
                statusbar: {
                    enabled: false
                },
                view: {
                    pushState: false,
                    pushStateSeparator:"",
                    pushStateOnLoad:true
                },
                routes: [],
                popup:{
                    closeOnEscape: true,
                },
                sheet: {
                    closeOnEscape: true,
                },
                popover: {
                    closeOnEscape: true,
                },
                actions: {
                    closeOnEscape: true,
                }
            });

            window.alert = function(text) {
                window.___app.dialog.alert(text, "");
            }

        }, 1000);

        window.__app.carrinho    = {
            model: {
                "itens":                        [],
                "formaPagamento":               "",
                "valor":                        0,  
                "total":                        0
            },
            "quantidade":                       0,
            data: {
                "itens":                        [],
                "formaPagamento":               "",
                "valor":                        0,  
                "total":                        0
            },
            clear: function(conf) {
                // var self            = this;
                window.localStorage.removeItem("_carrinho");
                window.__app.carrinho.getItens();
            },
            calc: function() {
                // var self            = this;
                console.log("calc()", window.__app.carrinho.data)
                var quantidade = 0;
                window.__app.carrinho.data.total     = 0;
                window.__app.carrinho.data.desconto  = 0;
                window.__app.carrinho.data.itens.forEach(function(item) {
                    quantidade += item.quantidade;
                    window.__app.carrinho.data.total = parseFloat(window.__app.carrinho.data.total) + parseFloat(item.total); 
                });
                window.__app.carrinho.data.valor     = window.__app.carrinho.data.total;
                if (window.__app.carrinho.data.entregaTaxa) {
                    window.__app.carrinho.data.total     = parseFloat(window.__app.carrinho.data.total) + parseFloat(window.__app.carrinho.data.entregaTaxa);
                }

                if (window.__app.carrinho.data.cupomNome && window.__app.carrinho.data.cupomValor && window.__app.carrinho.data.cupomMetodo) {
                    if (window.__app.carrinho.data.cupomMetodo == "valor") {
                        window.__app.carrinho.data.total     = parseFloat(window.__app.carrinho.data.total) - parseFloat(window.__app.carrinho.data.cupomValor);
                        window.__app.carrinho.data.desconto  = parseFloat(window.__app.carrinho.data.cupomValor);
                    } else if (window.__app.carrinho.data.cupomMetodo == "percentual") {
                        var porc                             = (parseFloat(window.__app.carrinho.data.total) / 100) * parseFloat(window.__app.carrinho.data.cupomValor);
                        window.__app.carrinho.data.desconto  = parseFloat(porc);
                        window.__app.carrinho.data.total     = parseFloat(window.__app.carrinho.data.total) - parseFloat(porc);
                    }
                }

                window.__app.carrinho.quantidade = quantidade;
                window.__app.$forceUpdate();
                window.localStorage.setItem("_carrinho", JSON.stringify(window.__app.carrinho.data));  

                // window.__app.carrinho.atualizarQuantidade();
                
                return window.__app.carrinho.data;
            },
            addItem: function(item) {
                // var self = this;
                window.__app.carrinho.data.itens.push(item);
                window.localStorage.setItem("_carrinho", JSON.stringify(window.__app.carrinho.data));  
                window.__app.carrinho.calc();            
            },
            delItem: function(item, scope) {
                // var self = this;
                console.log("delItem", item, scope);
                confirm("Você tem certeza que deseja remover este item do carrinho?", function() {
                    var i = window.__app.carrinho.data.itens.indexOf(item);

                    window.__app.carrinho.data.itens.splice(i, 1);

                    if (window.__app.carrinho.data.itens.length == 0) {
                        window.localStorage.removeItem("_carrinho");
                        window.__app.carrinho.getItens();
                    } else {
                        window.localStorage.setItem("_carrinho", JSON.stringify(window.__app.carrinho.data));
                        window.__app.carrinho.calc();
                    }

                    setTimeout(function() {
                        scope.$forceUpdate();
                    }, 100);

                });

            },
            getItens: function() {
                // var self            = this;
                try {
                    window.__app.carrinho.data       = JSON.parse(window.localStorage.getItem("_carrinho")) || JSON.parse(JSON.stringify(window.__app.carrinho.model));
                } catch(err) {
                    window.__app.carrinho.data       = JSON.parse(JSON.stringify(window.__app.carrinho.model));
                }

                console.log("Setou carrinho data", window.__app.carrinho.data);

                window.__app.$forceUpdate();
                setTimeout(function() {
                    window.__app.carrinho.calc();
                }, 500);

                // return window.__app.carrinho;            
            }
        };

        window.__app.carrinho.getItens();
        
    },
    mounted: function() {
        console.log("mounted geral >>");
        var self = this;
        setTimeout(function() {

            // $("#wrapper").fadeIn(1000);
         
            console.log("inicializou f7")

        }, 1000);
    },
    watch:{
        "formEndereco.cep": function(val) {
            var self = this;
            self.atualizarCEP(val);
        },     
        $route (to, from){
            var self = this;
            self.fixClass();
            setTimeout(function() {
                // window.fixHeight();
                window.scrollTo({
                    top: 0
                });
                
                gtag('config', self.config.googleAnalytics.id, {'page_title': to.meta.title});                 
                
                if (self.logged) {
                    self.getUser();
                }


            }, 100);
        }
    },
    on: {
    }       
})



// WEBPACK FOOTER //
// ./src/main.js